import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=f67f424a&scoped=true&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=f67f424a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67f424a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LazyLoad: require('/builds/master/frontend/frontend-universe/components/lazy-load.vue').default})
